_.templateSettings = {
  interpolate : /\{\{(.+?)\}\}/g
};

var path = window.location.pathname
var paths = path.split('/')
path = '/' + paths[1] + '/' + paths[2] + '/' + paths[3]
yr = paths[3].substring(4, 6);

$.ajax({
    url: path + '/line_item_search.json',
    success: callback_fuzzy
});

function callback_fuzzy(response){
  var line_item_search = response
  var listItemTemplate = _.template('<li tabindex={{index}} data-url="{{path}}/app_{{yr}}/act_{{yr}}/{{page}}"><div class="account">{{account}}</div></li>');
  var search_input = $('.search-line-item-form__input')
  var search_result = $('.search-line-item-form__list')
  var search_button = $('.search-line-item-form__button')

  function displayResults(event) {
    // The value we're searching for
    var search = search_input.val();

    var options = {
        pre: "<b>"
      , post: "</b>"

      // Each element in directors is an object, not a string. We can pass in a
      // function that is called on each element in the array to extract the
      // string to fuzzy search against. In this case, element.dir
      , extract: function(entry) {
          return entry.act + ' - ' + entry.ag;
          // return entry.act;
        }
    }

    // Filter!
    var filtered = fuzzy.filter(search, line_item_search, options);

    // Map the results to the html we want generated
    var results = filtered.slice(0,10).map(function(result, i){
      return listItemTemplate({
          agency: result.original.ag
        , account: result.string
        , page: result.original.htm
        , score: result.score
        , note: result.original.note
        , index: i
      });
    });

    // Update the html based on the
    if(search){
      search_result.html(results.join(''));
    }else{
      search_result.html('')
    };

    search_result.on('click', function(e){
      var liItem = (e.target.nodeName == "LI") ? e.target : e.target.parentElement //always returns <li>
      var tabindex = liItem.getAttribute('tabindex')
      parseSelected(tabindex)
      search_button.focus();
    })
  }

    onKeyUp();

    function parseSelected(tabindex){
      var selected = $('li[tabindex=' + tabindex + ']')
      var selectedText = selected[0].innerText
      var selectedUrl = selected.data('url')
      search_button.attr("href", selectedUrl) //url
      search_input.val(selectedText) //innerText
      search_result.css('display', 'none')
    }

    function onKeyUp(){
      var tabindex = -1;
        search_input.keyup(displayResults)
        search_input.add('.search-line-item-form__list').on('keydown', function(e) {
          var focusIndex = $(":focus").attr('tabindex')
          if(focusIndex){
            tabindex = focusIndex
          }
          search_result.css('display', 'block')
          keycode = e.which
          switch(true) {
            case (keycode === 8): //backsapce
              tabindex = -1;
              search_input.focus();
              break;
            case (keycode >= 49 && keycode <= 105 ): //0-9 and a-z
              tabindex = -1;
              search_input.focus();
              break;
            case (keycode === 40): //down
              tabindex++;
              $('li').removeClass('active')
              $('li[tabindex=' + tabindex + ']').focus().addClass('active');
              e.preventDefault()
              break;
            case (keycode === 38): //up
              tabindex--;
              $('li').removeClass('active')
              $('li[tabindex=' + tabindex + ']').focus().addClass('active');
              e.preventDefault()
              break;
            case (keycode === 13): //enter
              var selectedProps = parseSelected(tabindex)
              parseSelected(tabindex)
              search_button.focus();
              break;
            case (keycode === 27): //esc
              search_input.val('')
              search_result.css('display', 'none')
              break;
          }

        })
      }

  }

  function searchLineItem(search){
    $('.search-line-item-form__list').css('display', 'none')
    $('.search-line-item-form__input').val('')
  }
